export class ReconnectSourceAccountRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "claudeEnterprise",
            "baseName": "claudeEnterprise",
            "type": "ClaudeEnterpriseSourceAccountAttributesInput",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ReconnectSourceAccountRequest.attributeTypeMap;
    }
    constructor() {
    }
}
